<template>
  <div class="body">
    <component :is="fiche.component" v-if="fiche.component" v-bind="currentProperties" v-on="events"></component>
  </div>
</template>

<script lang="ts">
import {storeSession} from "@/generated/stores";
import Fiche from "@/framework/base/classes/Fiche";
import Route from "@/generated/classes/Route";
import {defineComponent, type PropType} from "vue";
import {useRouter} from "vue-router";
import type {RouteElements} from "@/framework/base/classes/Section.ts";

export default defineComponent({
  props: {
    fiche: {
      type: Object as PropType<Fiche>,
      required: true
    },
    fieldOnly: {
      type: Boolean
    },
    attribut: {
      type: Object as PropType<unknown> | undefined,
    },
    route: {
      type: Object as PropType<Route>,
      required: false
    },
    routeElement: {
      type: Object as PropType<RouteElements>,
      required: false
    },
    toggleNotif: {
      type: Boolean
    }
  },
  data() {
    return {
      router: useRouter(),
    }
  },
  computed: {
    events(): Record<string, () => void> {
      // eslint-disable-next-line
      const event: any = {};
      event["selectItem"] = (item: unknown) => this.selectItem(item);
      event["goBack"] = () => this.goBack();
      event["back"] = () => this.back();
      return event;
    },
    currentProperties() {
      return {
        [this.fiche.type]: this.fiche.data,
        readOnly: this.fiche.readonly,
        fieldOnly: this.fieldOnly,
        ressourceHeader: this.fiche.ressourceHeader,
        selectedFiche: this.fiche,
        attribut: this.attribut,
        route: this.route,
        showSection: this.fiche.showSection,
        toggleNotif: this.toggleNotif,
        routeElement: this.routeElement,
      };
    }
  },
  created(): void {
    storeSession.SetShowList(true);
  },
  beforeUnmount(): void {
    storeSession.SetShowList(false);
  },

  methods: {
    selectItem(item: unknown): void {
      this.$emit("selectItem", item)
    },
    back(): void {
      this.$emit("back")
    },
    goBack(): void {
      this.router.go(-1);
    }
  }
})

</script>
